import { render, staticRenderFns } from "./component1.vue?vue&type=template&id=9725cc06&scoped=true&"
import script from "./component1.vue?vue&type=script&lang=js&"
export * from "./component1.vue?vue&type=script&lang=js&"
import style0 from "./component1.vue?vue&type=style&index=0&id=9725cc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9725cc06",
  null
  
)

export default component.exports